import { FC, ReactNode } from "react";

export const FadeStyleOff: FC<{
    children: ReactNode;
}> = ({ children }) => <div>{children}</div>;
